import React from 'react';
import { Button, Spin } from 'antd';
import { CANCEL_REQUEST } from '../../constants/common';

const SpinnerWithButton = ({
  onClick,
  disabled,
  executing = true,
  message = CANCEL_REQUEST,
  showButton = true,
  className = '',
  children,
}) => (
  <Spin
    tip={
      showButton ? (
        <Button onClick={onClick} disabled={disabled} type="primary">
          {message}
        </Button>
      ) : null
    }
    spinning={executing}
    className={className}
    size="large"
  >
    {children}
  </Spin>
);

export default SpinnerWithButton;
